import React from 'react';

export const FailureIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="201"
    height="204"
    viewBox="0 0 201 204"
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-585 -317)">
        <g transform="translate(526.917 255.417)">
          <path
            fill="#EBEAF9"
            d="M222.074 202.763c-27.908 21.066-11.685 66.7-67.077 63.028-34.378-2.279-40.387-35.939-53.066-46.367-15.994-13.155-45.467-1.63-55.159-34.422-7.683-25.996 11.357-32.933 23.805-44.398 17.497-16.115 7.434-42.432 20.86-70.84 13.428-28.41 88.182-36.546 107.867 12.983 12.052 30.323 52.9 9.94 64.952 52.849 12.052 42.908-18.078 48.973-42.182 67.167z"
            transform="rotate(-135 156 156.5)"
          />
          <g transform="translate(89.083 100.583)">
            <path
              fill="#7540EE"
              d="M2.243.583h120.625a2.16 2.16 0 012.16 2.214l-2.606 104.63a2.16 2.16 0 01-2.16 2.105H76.9l-14.856 14.051c-9.637-9.367-18.486-14.05-26.547-14.05-7.665 0-18.714.351-33.149 1.055a2.16 2.16 0 01-2.265-2.157V2.743a2.16 2.16 0 012.16-2.16z"
            />
            <path
              fill="#FFF"
              d="M11.243 8.583h120.625a2.16 2.16 0 012.16 2.214l-2.606 104.63a2.16 2.16 0 01-2.16 2.105H85.9l-14.856 14.051c-9.637-9.367-18.486-14.05-26.547-14.05-7.665 0-18.714.351-33.149 1.055a2.16 2.16 0 01-2.265-2.157V10.743a2.16 2.16 0 012.16-2.16z"
            />
            <rect
              width="16"
              height="4"
              x="35.154"
              y="52.654"
              fill="#320056"
              fillRule="nonzero"
              rx="2"
              transform="rotate(-45 43.154 54.654)"
            />
            <rect
              width="16"
              height="4"
              x="35.154"
              y="52.654"
              fill="#320056"
              fillRule="nonzero"
              rx="2"
              transform="rotate(45 43.154 54.654)"
            />
            <rect
              width="16"
              height="4"
              x="88.154"
              y="52.654"
              fill="#320056"
              fillRule="nonzero"
              rx="2"
              transform="rotate(-45 96.154 54.654)"
            />
            <rect
              width="16"
              height="4"
              x="88.154"
              y="52.654"
              fill="#320056"
              fillRule="nonzero"
              rx="2"
              transform="rotate(45 96.154 54.654)"
            />
            <rect
              width="35"
              height="4"
              x="52.154"
              y="79.654"
              fill="#320056"
              fillRule="nonzero"
              rx="2"
            />
            <path
              fill="#320056"
              d="M133.503 68.383c5.612 0 12.42-2.365 12.42-12.803s-11.291-24.997-12.42-24.997c-1.13 0-12.42 14.559-12.42 24.997s6.808 12.803 12.42 12.803z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
